import { NOT_FOUND } from '../errorTypes';

/* eslint-disable import/prefer-default-export */
export function processQuerySnapshotItems(querySnapshot, idField = 'id') {
  const items = [];
  querySnapshot.forEach(doc => items.push(Object.assign(doc.data(), { [idField]: doc.id })));
  return items;
}

export function rejectIfNotFound(doc) {
  if (!doc.exists) {
    return Promise.reject(NOT_FOUND);
  }

  return doc.data();
}



// WEBPACK FOOTER //
// ./src/firebase/repositories/utils.js